var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPassQuestionBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.09016,
    height: 6.08899,
    rx: 1.02461,
    transform: "matrix(-1 0 0 1 6.09016 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44172 3.04394C6.44172 2.81041 6.42135 2.62109 6.39623 2.62109H2.58326C2.55814 2.62109 2.53777 2.81041 2.53777 3.04394C2.53777 3.27747 2.55814 3.46679 2.58326 3.46679H6.39623C6.42135 3.46679 6.44172 3.27747 6.44172 3.04394Z",
    fill: "#1C1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09358 0.803896C3.98876 0.690368 3.81882 0.690368 3.71401 0.803896L1.83523 2.83884C1.73042 2.95237 1.73042 3.13644 1.83523 3.24997L3.71401 5.28492C3.81882 5.39844 3.98876 5.39844 4.09358 5.28492C4.19839 5.17139 4.19839 4.98732 4.09358 4.87379L2.40459 3.04441L4.09358 1.21502C4.19839 1.10149 4.19839 0.917424 4.09358 0.803896Z",
    fill: "#1C1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0003 3.04257C13.0003 2.76233 12.9637 2.53516 12.9184 2.53516H6.05509C6.00987 2.53516 5.97321 2.76233 5.97321 3.04257C5.97321 3.32281 6.00987 3.54999 6.05509 3.54999H12.9184C12.9637 3.54999 13.0003 3.32281 13.0003 3.04257Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPassQuestionBackIcon);
export default __webpack_public_path__ + "static/media/calendar-pass-question-back-icon.055290e265a5146af1747d3fb1759e13.svg";
export { ForwardRef as ReactComponent };